import React from "react";
// import { InfoWindow } from "react-google-maps";
import { InfoWindowF } from "@react-google-maps/api";
import * as moment from "moment";
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";
import { grey } from "@material-ui/core/colors";


import { getVehicleIcon } from "../../../../includes/util";
import * as globalVariables from "../../../../includes/variables";

const ColorButton = withStyles((theme) => ({
  root: {
    color: theme.palette.getContrastText(grey[700]),
    backgroundColor: grey[700],
    "&:hover": {
      backgroundColor: grey[800],
    },
  },
}))(Button);

const DisplayInfoWindow = (props) => {
  const { location, mapCenter } = props;

  const Latitude = Number(location.Latitude) !== 0 ? Number(location.Latitude) : (Number(mapCenter.lat) !== 0 ? mapCenter.lat : 0);
  const Longitude = Number(location.Longitude) !== 0 ? Number(location.Longitude) : (Number(mapCenter.lng) !== 0 ? mapCenter.lng : 0);


  //console.log(window.google.maps.getCenter());
  const setHistory = () => {
    //console.log('setHistory', location.VehicleId);
    props.onSelectedHistory(location);
  };



  const getMarkerInfoWindow = (selectedLocation) => {
    return (
      <div className="vehicle-locate-popup shadow-sm p-2" 
        style={{ 
          width: "800px",
          height: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignContent: "center",
          alignSelf: "center",
          overflow: 'hidden' }}
      >
        <div className="row no-gutters">
          <div className="col-12 d-flex align-items-center ">
            <img
              src={getVehicleIcon(location.RucMonkeyVehicleTypeId)}
              alt="vehicleType"
            />
            <p>
              {selectedLocation.VehiclePlate}-{selectedLocation.VehicleCode}
            </p>
          </div>          
          <div className="col-6 d-flex align-items-center mt-3">
            <img
              src={globalVariables.imgPath.fleetGrey}
              alt="fleets"
              style={{ width: 25 }}
            />
            <p>
              {selectedLocation?.FleetName
                ? selectedLocation?.FleetName
                : "N/A"}
            </p>
          </div>
          <div className="col-12 d-flex align-items-center mt-3">
            <img
              src={globalVariables.imgPath.odometerGrey}
              alt="odometer"
              style={{ width: 25 }}
            />
            <p>{Number(selectedLocation.Odometer).toFixed(0)} Km</p>
          </div>

          <div className="col-12 d-flex align-items-center mt-3 mb-3">
            <img src={globalVariables.imgPath.date} alt="dateandtime" />
            <p>
              {moment(selectedLocation.OdometerReadingTimestamp).format(
                "DD/MM/YYYY HH:mm:ss"
              )}
            </p>
          </div>

          <div className="col-12 d-flex align-items-center  mb-3">
            <img src={globalVariables.imgPath.location} alt="location" />
            <p>{selectedLocation.LocationDescription}</p>
          </div>

          {getCommandButtons()}
        </div>
      </div>
    );
  };

  const selectMaker = () => {
    //console.log('selectMaker');
    props.unSelectMarker(null);
  };

  const getCommandButtons = () => {

    if (location.ReadingId) return null;

    return (
      <div className="col-12 d-flex justify-content-center">
        <ColorButton
          variant="contained"
          onClick={setHistory}
        //style={{ display: `${location.LocationId ? "none" : "block"}` }}
        >
          History
        </ColorButton>


      </div>
    );
  };

  return (
    <InfoWindowF
      onCloseClick={selectMaker}
      position={{
        lat: Latitude,
        lng: Longitude,
      }}
      options={{        
        zIndex: 999,
        maxWidth: 600,
        disableAutoPan: true,
        pixelOffset: new window.google.maps.Size(0, -60),
        overflowY: 'hidden',
        overflowX: 'hidden'
      }}
    >
      {getMarkerInfoWindow(location)}
    </InfoWindowF>
  );
};

export default DisplayInfoWindow;
